import { Buttons } from '@taxdown/piccolo-web';
import styled, { css } from 'styled-components';
import { FRONT_PLANS } from 'Constants/plans';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

const planTextColors = {
  [FRONT_PLANS.BASIC]: css`
    background-color: ${({ theme: { colors } }) => colors.pro_400};
  `,
  [FRONT_PLANS.PRO]: css`
    background-color: ${({ theme: { colors } }) => colors.full_400};
  `,
};

export const PlanButton = styled(Buttons.Classic)`
  ${({ type }) => planTextColors[type]}
  span {
    color: ${({ theme: { colors } }) => colors.dark_500};
    svg {
      margin-left: 4px;
    }
  }
  ${({ isFlow }) =>
    isFlow &&
    css`
      @media screen and (max-width: ${MOBILE_WIDTH}) {
        display: none;
      }
    `}
`;
